<ng-container *ngrxLet="currentRouteUrl$; let currentRouteUrl">
  <ng-container *ngrxLet="canUseFacebookPixel$; let canUseFacebookPixel">
    <app-facebook-pixel *ngIf="canUseFacebookPixel"></app-facebook-pixel>
  </ng-container>

  <app-cookies-consent *ngIf="showCookiesConsent"></app-cookies-consent>

  <app-header
    *ngIf="showMainHeader(currentRouteUrl)"
    [solid]="isSolidHeader(currentRouteUrl)"
    [showNavigation]="!isOnLoginPage(currentRouteUrl)"
    class="header"
  ></app-header>
  <app-cms-navigation
    *ngIf="showCmsNavigation(currentRouteUrl)"
  ></app-cms-navigation>

  <div
    class="app"
    [ngClass]="{
      'app__cms-navigation': showCmsNavigation(currentRouteUrl),
      'app--full-width': isFullWidth(currentRouteUrl)
    }"
    appResize
    (resizeEvent)="handleResizeEvent($event.width)"
  >
    <div class="app__content flex-column">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>
<simple-notifications></simple-notifications>
<app-popup></app-popup>
